import {get,post} from '@/util/http';
import { Notification } from 'uiv'

const forum = {
    state:{},
    mutations:{},
    actions:{
        async meetlistasmx({},params){//会议安排信息列表
            const res = await get('/CifitSystem/api/seminar/meeting/meetlistasmx.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async meetinfo({},params){//会议详情信息
            const res = await get('/CifitSystem/api/seminar/meeting/meetinfo.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async getGuide({},params){//服务指南信息查询
            const res = await get('/CifitSystem/api/seminar/guide/getGuide.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async titlelist({},params){//每届讲稿汇编的主题名称列表
            const res = await get('/CifitSystem/api/seminar/lecture/titlelist.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async getLecture({},params){//获取讲稿汇编信息
            const res = await get('/CifitSystem/api/seminar/lecture/getLecture.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
    }
}

export default forum


// WEBPACK FOOTER //
// ./src/store/modules/forum.js